import { $t } from "helpers/translator"

const SetMyWorkingHours = {
    steps: [
        {
            target: '#openingHours',
            title: $t('global.tours.SetMyWorkingHours.0.title'),
            content: $t('global.tours.SetMyWorkingHours.0.content'),
        },
        {
            target: '#openingHours',
            title: $t('global.tours.SetMyWorkingHours.1.title'),
            content: $t('global.tours.SetMyWorkingHours.1.content'),
            locale: {
                last: $t('global.tours.SetMyWorkingHours.1.confirm')
            }
        }
    ],
    url: '/account'
}

export default SetMyWorkingHours